import React, { createContext, useContext, useEffect, useState } from "react";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import { useSelector } from "react-redux";
import { endpoint } from "../../assets/api/endpoint";

// Create Context
const GameSocketContext = createContext();
export const useGameSocket = () => useContext(GameSocketContext);

const GameSocketListener = ({ children }) => {
    const { userAuthId } = useSelector((state) => state.loginInfo);
    const [socketGame, setSocketGame] = useState([]); 

    useEffect(() => {
        const socket = new SockJS(`${endpoint.BASE_URL_STAGING}public/ws`);
        const stompClient = Stomp.over(socket);

        stompClient.connect({}, () => {
            stompClient.subscribe("/game", (message) => {
                const payload = JSON.parse(message.body);
                setSocketGame((prev) => {
                    const updated = [...prev, payload];
                    return updated;
                });

            });
        });

        return () => {
            if (stompClient && stompClient.connected) {
                stompClient.disconnect();
            }
        };
    }, [userAuthId]);
    return (
        <GameSocketContext.Provider value={{ socketGame }}>
            {children}
        </GameSocketContext.Provider>
    );
};

export default  GameSocketListener;
